import { type ProductIdsType } from '@/services/api/premium/types'

export const PRODUCT_IDS = {
  openTableMenus: 'prod_TwvQIJwONOXNYd',
  openTableMenusPlus: 'prod_U0bn8Wp0p0rjfe',
  openTableMenusPremium: 'prod_U0bqT2HF4ODXGf',
  base: 'prod_TpNP5khYBUT0ox',
  pro: 'prod_TpNiFNyrNRXAjf',
  kitchenSync: 'prod_TpNoVgQsN4heFR',
} as const

const OPEN_TABLE_FEATURES = {
  menus: 'Menus',
  menusGoogle: 'Menus, including Google Menu',
  menuWidgets: 'Menu Widgets',
  openTableMenuIntegration: 'OpenTable Menu Integration',
  posIntegrations: 'POS Integrations',
  accessToListingsPublishers: 'Access to 60+ Listings Publishers',
  listingsAnalytics: 'Listings Analytics',
  hoursWidget: 'Hours Widget',
} as const

const BASE_FEATURES = {
  unlimitedListingsUpdates: 'Unlimited Updates to 70+ Listings Publishers',
  automatedMenuUpdates: 'Automated Menu Updates',
  posIntegrations: 'POS Integrations',
  hoursMenuWidgets: 'Hours + Menus Website Widgets',
  inDepthSearchAnalytics: 'In-Depth Search Analytics',
} as const

const PRO_FEATURES = {
  ...BASE_FEATURES,
  reviewsMonitoring:
    'Review Monitoring: Yelp, Google, Facebook, Doordash, Grubhub, Uber Eats, ezCater',
  reviewsResponse: 'Review Response: Yelp, Google, Facebook',
  aiSuggestedReviewResponse: 'AI-powered Suggested Review Response',
  customReviewNotifications: 'Custom Review Notifications',
  advancedReviewInsights: 'Advanced Review Insights + Sentiment Analysis',
  aiReviewSummaries: 'AI Review Summaries',
} as const

const KITCHEN_SYNC_FEATURES = {
  ...PRO_FEATURES,
  firstPartyReviews: 'First Party Reviews',
  socialManagement: 'Social Management with Google Posts + Apple Showcase',
  accessToNewProducts: 'Access to new products + features as they are released',
} as const

export const FEATURES_BY_PRODUCT_ID: Record<ProductIdsType, string[]> = {
  [PRODUCT_IDS.openTableMenus]: [
    OPEN_TABLE_FEATURES.menus,
    OPEN_TABLE_FEATURES.menuWidgets,
    OPEN_TABLE_FEATURES.openTableMenuIntegration,
  ],
  [PRODUCT_IDS.openTableMenusPlus]: [
    OPEN_TABLE_FEATURES.menusGoogle,
    OPEN_TABLE_FEATURES.menuWidgets,
    OPEN_TABLE_FEATURES.openTableMenuIntegration,
    OPEN_TABLE_FEATURES.posIntegrations,
  ],
  [PRODUCT_IDS.openTableMenusPremium]: [
    OPEN_TABLE_FEATURES.menusGoogle,
    OPEN_TABLE_FEATURES.menuWidgets,
    OPEN_TABLE_FEATURES.openTableMenuIntegration,
    OPEN_TABLE_FEATURES.posIntegrations,
    OPEN_TABLE_FEATURES.accessToListingsPublishers,
    OPEN_TABLE_FEATURES.listingsAnalytics,
    OPEN_TABLE_FEATURES.hoursWidget,
  ],
  [PRODUCT_IDS.base]: [...Object.values(BASE_FEATURES)],
  [PRODUCT_IDS.pro]: [...Object.values(PRO_FEATURES)],
  [PRODUCT_IDS.kitchenSync]: [...Object.values(KITCHEN_SYNC_FEATURES)],
}

export const MIN_STORES_AMOUNT = 1
export const NO_STORES = 0
